export default {
  text: 'rgb(190, 172, 116)',
  primary: '#92151e',
  secondary: '#bf1f2e',
  background: 'black',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
